import { ReactNode } from 'react';

export const extractAriaProps = (props: Record<string, ReactNode>) => {
    const ariaProps: Record<string, ReactNode> = {};
    const restProps: Record<string, ReactNode> = {};

    Object.keys(props).forEach((key) => {
        const value = props[key];
        if (key.startsWith('aria-') && typeof value === 'string') {
            ariaProps[key] = value;
        } else {
            restProps[key] = value;
        }
    });

    return [ariaProps, restProps];
};
